import styled from 'styled-components';

export const StyledQuickPlayContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    border: 1px solid #CBCBCB;
    width: 65%;
    padding: 20px;

    @media (max-width: 1480px) {
        width: 50%;
    }

    @media (max-width: 900px) {
        width: 100%;
        box-sizing: border-box;
    }
`

export const StyledQuickPlayWrapper = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 1480px) {
        flex-direction: column;
    }

    @media (max-width: 900px) {
        flex-direction: row;
    }

     @media (max-width: 620px) {
        flex-direction: column;
    }
`

export const StyledQuickPlayInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    justify-content: space-around;

     @media (max-width: 1480px) {
        width: 100%;
    }
`

export const StyledBannerImageWrapper = styled.div`
    width: 50%;
    margin-top: 20px;

    @media (max-width: 1480px) {
        width: 100%;
    }
`

export const StyledTableInfo= styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: 10px;
`

export const StyledBadge= styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 12px;
    line-height: 10px;
    background-color: #1D591A;
    height: 25px;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 1.5rem;
    cursor: pointer;
`

export const StyledButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 15px;
`

export const StyledTableInfoTitle= styled.p`
    color: white;
    font-size: 12px;
    line-height: 10px;
    opacity: 0.6;
    margin-bottom: 10px;
`